export default {
  getAttribute: (state) => state.attribute,
  getAttributes: (state) => state.attributes,
};
